import { Infotip } from '~/components';
import { statusColorThemes } from '~/styles/themes.css';
import { clsx } from '~/styles/utils';

import { tagStyle } from './PricingInfoLabel.css';

type Props = {
  label: string;
  tooltip?: string;
  variant: Extract<keyof typeof statusColorThemes, 'success' | 'warning'>;
};

export const PricingInfoLabel = ({ label, tooltip, variant }: Props) => {
  return (
    <div className={clsx(statusColorThemes[variant], tagStyle)}>
      {label}

      {tooltip && <Infotip>{tooltip}</Infotip>}
    </div>
  );
};
